import { Injectable, OnDestroy } from '@angular/core';
import { Instrument } from '../model/trade';
import { BoardId, MarketId } from '../model/common';
import { filter, map, Observable, of, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InstrumentStorageService implements OnDestroy {

  private instruments = new Map<string, Instrument>()
  private updateSubject = new ReplaySubject<void>(1)

  ngOnDestroy(): void {
    this.updateSubject.complete()
  }

  add(instruments: Instrument | Instrument[]) {
    if (!Array.isArray(instruments)) {
      instruments = [instruments]
    }
    instruments.forEach(instrument => {
      const key = `${instrument.market},${instrument.board},${instrument.symbol}`
      this.instruments.set(key, instrument)
    })
    this.updateSubject.next()
  }

  get(market: MarketId, board: BoardId, symbol: string) {
    const key = `${market},${board},${symbol}`
    return this.instruments.get(key)
  }

  listen(market: MarketId): Observable<Instrument[]>
  listen(market: MarketId, board: BoardId): Observable<Instrument[]>
  listen(market: MarketId, board: BoardId, symbol: string): Observable<Instrument>
  listen(market: MarketId, board?: BoardId, symbol?: string): Observable<Instrument | Instrument[]> {
    let key = market
    if (board) {
      key += `,${board}`
    }
    if (symbol) {
      key += `,${symbol}`
    }

    const instrument = this.instruments.get(key)
    if (instrument) {
      return of(instrument)
    }

    return this.updateSubject.pipe(
      map(() => {
        const instrument = this.instruments.get(key)
        if (instrument) {
          return instrument
        }
        const result: Instrument[] = []
        this.instruments.forEach((v, id) => {
          if (id.startsWith(key)) {
            result.push(v)
          }
        })
        return result
      }),
      filter(data => data != undefined)
    )
  }

}
